<template>
<router-link :to="to">
                <v-list-item>
              <v-list-item-icon>
                <v-icon>{{icon}}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                {{title}}
                </v-list-item-title>
            </v-list-item>

            </router-link>
</template>

<script>
export default {
    name: "DrawerItemLink",
    props: {
        icon: String,
        title: String,
        to: String
    }
}
</script>